import React from "react";
import { styled } from "@sourceful/shared-components";
import { SanityTechnicalContentSpecItem } from "@sourceful/shared-types";

const TechnicalContentSpecItemHeaderContainer = styled("div", {
  display: "flex",
  alignItems: "center",
});

const ColourCircle = styled("div", {
  height: "20px",
  width: "20px",
  borderRadius: "50%",
  marginRight: "20px",
});

interface TechnicalContentSpecItemHeaderProps {
  item: SanityTechnicalContentSpecItem;
}

const TechnicalContentSpecItemHeader = ({ item }: TechnicalContentSpecItemHeaderProps) => {
  const { colour, title } = item;

  return (
    <TechnicalContentSpecItemHeaderContainer>
      <ColourCircle style={{ backgroundColor: colour.value }} />
      {title}
    </TechnicalContentSpecItemHeaderContainer>
  );
};

export default TechnicalContentSpecItemHeader;
